module.exports = __webpack_public_path__ + "static/media/yakimono_thumb_even.f32ce46b.webp";